import React, { useState, useEffect } from 'react';
import { auth } from './utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import LandingScreen from './components/Landing';
import SetupScreen from './components/Setup';
import ActiveSpeechScreen from './components/ActiveSpeech';
import SummaryScreen from './components/Summary';

export default function App() {
  const [currentScreen, setCurrentScreen] = useState('landing');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checklistItems, setChecklistItems] = useState([]);
  const [completedItems, setCompletedItems] = useState(new Set());
  const [speechDuration, setSpeechDuration] = useState(0);
  const [variationsCache, setVariationsCache] = useState({});

  // Listen for auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
      if (user && currentScreen === 'landing') {
        setCurrentScreen('setup');
      } else if (!user) {
        setCurrentScreen('landing');
      }
    });

    return () => unsubscribe();
  }, [currentScreen]);

  // Reset app state
  const resetApp = () => {
    setChecklistItems([]);
    setCompletedItems(new Set());
    setSpeechDuration(0);
    setVariationsCache({});
  };

  // Create checklist with variations
  const handleCreateChecklist = (items, cache) => {
    setChecklistItems(items);
    setVariationsCache(cache);
    setCurrentScreen('active');
  };

  // Complete speech
  const handleCompleteSpeech = (duration) => {
    setSpeechDuration(duration);
    setCurrentScreen('summary');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  // Render current screen
  switch (currentScreen) {
    case 'landing':
      return <LandingScreen />;
    
    case 'setup':
      return (
        <SetupScreen
          user={user}
          onCreateChecklist={handleCreateChecklist}
        />
      );
    
    case 'active':
      return (
        <ActiveSpeechScreen
          user={user}
          items={checklistItems}
          variationsCache={variationsCache}
          completedItems={completedItems}
          setCompletedItems={setCompletedItems}
          onComplete={handleCompleteSpeech}
        />
      );
    
    case 'summary':
      return (
        <SummaryScreen
          totalItems={checklistItems.length}
          completedCount={completedItems.size}
          duration={speechDuration}
          onUseSameList={() => {
            setCompletedItems(new Set());
            setSpeechDuration(0);
            setCurrentScreen('active');
          }}
          onStartFresh={() => {
            resetApp();
            setCurrentScreen('setup');
          }}
        />
      );
    
    default:
      return <LandingScreen />;
  }
}